<template>
  <div>
    <custom-actions :panel="false">
      <template #header>
        <el-button type="primary" @click="showForm(null)">新增组织</el-button>
      </template>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe  default-expand-all border v-loading="loading" :data="tableData" row-key="deptId" :tree-props="{children: 'childNode'}">
        <el-table-column label="部门名称" prop="deptName"></el-table-column>
        <el-table-column label="排序" prop="orderNum" width="120"></el-table-column>
        <el-table-column label="编码" prop="deptNo" width="120"></el-table-column>
        <el-table-column label="操作" width="180">
          <template v-slot="{ row }">
            <el-button v-if="row.parentDeptId !== '1'" type="text" @click="showForm(row)">编辑</el-button>
            <el-button v-if="row.parentDeptId !== '1'" type="text" @click="deleteDept(row.deptId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="提示" :close-on-click-modal="false" class="global-dialog global-dialog-w400" :visible.sync="dialogVisible" >
      <el-form :model="form" :rules="rules" ref="form" class="form-content"  label-width="80px">
        <el-form-item label="部门名称" prop="deptName">
          <el-input v-model="form.deptName" placeholder="请输入部门名称"/>
        </el-form-item>
        <el-form-item label="上级部门" prop="parentDeptId">
          <el-cascader
            ref="cascader"
            v-model="form.parentDeptId"
            :show-all-levels="false"
            :options="tableData"

            :props="{ emitPath: false, label: 'deptName', value: 'deptId', children: 'childNode', checkStrictly: true }"
            @change="deptChange">
          </el-cascader>
        </el-form-item>
        <el-form-item label="排序" prop="orderNum">
          <el-input v-model="form.orderNum" type="number" placeholder="请输入排序"/>
        </el-form-item>
        <el-form-item label="编码" prop="deptNo">
          <el-input v-model="form.deptNo" placeholder="请输入编码"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'OrganizeManage',
  data () {
    return {
      tableData: [],
      loading: false,
      form: {
        deptName: null,
        parentDeptId: '',
        orderNum: null,
        deptNo: ''
      },
      rules: {
        deptName: [{ required: true, message: '请输入部门名称' }],
        parentDeptId: [{ required: true, message: '请选择上级部门' }],
        orderNum: [{ required: true, message: '请输入排序' }],
        deptNo: [{ required: true, message: '请输入编码' }]
      },
      dialogVisible: false
    }
  },
  async  created () {
    await this.loadData()
  },
  methods: {
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const url = this.form.deptId ? this.$apis.system.updateSysDept : this.$apis.system.insertSysDept
          this.$axios.post(url, this.form).then(() => {
            this.dialogVisible = false
            this.loadData()
          })
        }
      })
    },
    loadData () {
      this.loading = true
      return this.$axios.get(this.$apis.system.selectSysDeptByList).then(res => {
        this.tableData = res
      }).finally(() => {
        this.loading = false
      })
    },
    deptChange (value) {
      if (this.form.deptId === value) {
        this.$message.error('不能选择自身作为上级')
        this.form.parentDeptId = '1'
        this.$refs.cascader.dropDownVisible = false
      }
    },
    loadDetails (deptId) {
      this.$axios.get(this.$apis.system.selectSysDeptByDeptId, {
        params: { deptId }
      }).then(res => {
        this.form = res
      })
    },
    showForm (row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        if (row) {
          this.loadDetails(row.deptId)
          this.$refs.form.clearValidate()
        } else {
          this.form = {
            deptName: null,
            parentDeptId: ''
          }
          this.$refs.form.resetFields()
        }
      })
    },
    deleteDept (deptId) {
      this.$confirm('确认删除该材料, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.system.deleteSysDept, {
          deptId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.el-select {
  width: 100%;
}

.el-cascader {
  width: 100%;
}
.form-content{
  padding: 30px 40px 20px 20px;
}

</style>
